var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[(_vm.total>0)?_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.pageSize,"page-count":_vm.pageCount,"current-page":_vm.currentPageIndex,"total":_vm.total},on:{"update:currentPage":function($event){_vm.currentPageIndex=$event},"update:current-page":function($event){_vm.currentPageIndex=$event},"current-change":_vm.OnCurrentChanged}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aed9a758","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages.vue
// module id = null
// module chunks = 